import { $flattenRootToSingleParagraph } from '#pplx/frontend/composer-sdk/lexical/utils/rootFlattening.js';
import { RootNode } from 'lexical';
// RichTextPlugin can create multiple paragraphs from paste or keyboard input;
// ResizableInput is a single logical paragraph, so flatten any extra blocks.
export const rootNodeTransform = (editor) => editor.registerNodeTransform(RootNode, (rootNode) => {
    if (rootNode.getChildrenSize() > 1) {
        $flattenRootToSingleParagraph();
    }
});
//# sourceMappingURL=rootNodeTransform.js.map